module.exports = __webpack_public_path__ + "static/media/Sleper_wachten_01.7edf38b6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/05/02/assets/Sleper_wachten_01.mp3
// module id = 566
// module chunks = 0